export class UserRefreshToken {
    userId: number;
    refreshToken: string;
    accessToken: string;
    portal: boolean;
}